export const MOS = 'mos';
export type MOS = typeof MOS;

export const REQUEST_MOS_RESYNC_PLAYLIST = `${MOS}/requestMosResyncPlaylist`;
export type REQUEST_MOS_RESYNC_PLAYLIST = typeof REQUEST_MOS_RESYNC_PLAYLIST;

export type MosStateType = {};
